import { DataModel } from "common/models/utility-models/base-model";

export class ChangeMentorModel extends DataModel {
    mentorId: string = ''
    mentor_email: string = ''
    mentor_mobile: string = '';
    remarks: string = '';
}